// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { navigatorLock } from '@supabase/auth-js';
import { Capacitor } from '@capacitor/core';
import type { Database } from './types';
import { makePatientLock } from '../../lib/authLockPatience';

const SUPABASE_URL =
  import.meta.env.NEXT_PUBLIC_SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL;

export const supabaseUrl = SUPABASE_URL as string;

const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// O GoTrueClient só usa o navigatorLock quando `navigator.locks` existe;
// forçar o wrapper num WebView sem a API quebraria onde hoje cai no lockNoOp.
// O guard replica a seleção default do próprio auth-js (GoTrueClient.js:135-142).
const hasNavigatorLocks =
  typeof globalThis.navigator !== 'undefined' && !!globalThis.navigator.locks;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Lock de auth PACIENTE (issue #461): o MESMO navigatorLock do auth-js,
    // com todo acquireTimeout POSITIVO elevado a 30s. Mata o steal-cascade da
    // rajada de montagem do /mirror (VYV-FRONTEND-3Q/4). O porquê do número,
    // o trade-off e por que a opção `lockAcquireTimeout` NÃO funcionaria (o
    // supabase-js não a repassa) estão em src/lib/authLockPatience.ts.
    ...(hasNavigatorLocks ? { lock: makePatientLock(navigatorLock) } : {}),
    // PKCE is required for the native (Capacitor) Google OAuth deep-link flow.
    // signInWithOAuth stores a one-time code_verifier in `storage` (localStorage,
    // which persists across the SFSafariViewController round-trip because the
    // WKWebView origin stays capacitor://localhost), and the appUrlOpen handler
    // in App.tsx calls exchangeCodeForSession with the returned ?code=.
    // Without this, the default 'implicit' flow returns #access_token and stores
    // NO verifier, so the native exchange fails with "both auth code and code
    // verifier should be non-empty" (Sentry VYV-FRONTEND-Q).
    // Web is unaffected: detectSessionInUrl (default true) auto-exchanges the
    // ?code= on /auth/callback. Apple native uses signInWithIdToken (no PKCE).
    flowType: 'pkce',
    // Disable the SDK's automatic URL session detection on NATIVE only. The
    // PKCE flow state is single-use, and on native the code is consumed by our
    // own handler (App.tsx appUrlOpen + the /auth route effect). Leaving
    // detectSessionInUrl on would make the SDK auto-exchange the ?code= in the
    // webview URL too, racing a SECOND exchange that fails with "invalid flow
    // state, no valid flow state found" (Sentry VYV-FRONTEND-S). Web keeps it
    // true so the standard /auth/callback auto-exchange continues to work.
    detectSessionInUrl: !Capacitor.isNativePlatform(),
  }
});